import React from 'react';

export const DollarAmountUSD = ({ amount }: { amount: string }) => (
  <span>
    {amount} <span className="font-light text-[.85em]">USD</span>
  </span>
);
